export default __webpack_public_path__ + "static/summit_stars_4_5-ce4869e23501efb499e97a844be24d5e.svg";